export default "__VITE_ASSET__8Ww2FYY4__"